var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92408 1C9.8617 1 11.2145 2.33523 11.2145 4.24873V9.75127C11.2145 11.6648 9.8617 13 7.92408 13H3.29043C1.35281 13 0 11.6648 0 9.75127V4.24873C0 2.33523 1.35281 1 3.29043 1H7.92408ZM14.3664 2.90319C14.7176 2.72451 15.1296 2.74319 15.4648 2.95436C15.8 3.16471 16 3.53019 16 3.92979V10.0707C16 10.4711 15.8 10.8358 15.4648 11.0461C15.2816 11.1606 15.0768 11.2191 14.8704 11.2191C14.6984 11.2191 14.5264 11.1785 14.3656 11.0965L13.1808 10.4987C12.7424 10.2762 12.4704 9.82948 12.4704 9.33324V4.66644C12.4704 4.16938 12.7424 3.72268 13.1808 3.50177L14.3664 2.90319Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.f5b224dd7f1106db5524b24c294b0578.svg";
export { ForwardRef as ReactComponent };